import { USE_MOCKS } from '@/lib/mocks';
import { AuthApiDatasource } from '../data/datasources/auth-api.datasource';
import { AuthMockDatasource } from '../data/datasources/auth-mock.datasource';
import { AuthRepositoryImpl } from '../data/repositories/auth.repository.impl';

/**
 * Login real (Firebase Auth + `POST /auth/sign-in`, com o `x-scope-id` desta
 * plataforma) ou o simulado, pelo `VITE_USE_MOCKS` — como os outros módulos.
 */
const mock = USE_MOCKS ? new AuthMockDatasource() : null;

export const authContainer = {
  repository: new AuthRepositoryImpl(mock ?? new AuthApiDatasource()),
  /**
   * Quem está logado, para os **mocks** de envio, que não têm token de onde
   * tirar o dono. A API real não usa isto: o back lê o usuário do token.
   */
  currentUserId: () => mock?.currentSession()?.id ?? null,
  /**
   * Se a sessão tem perfil nesta plataforma, para os **mocks** de envio
   * responderem 403 como o back faria (`ScopedProfileGuard`).
   */
  currentUserHasProfile: () => mock?.currentSession()?.hasProfile ?? false,
};
